import React, { useEffect } from "react";
import InspectionList from "./inspectionList";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { ACCESS_DENIED } from "../../../constant/routeContant";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import { ORG_ID } from "../../../constant/constant";
import { useDispatch, useSelector } from "react-redux";
import * as inspectionAction from "../../../redux/actions/incpectionAction";
import * as assetsAction from "../../../redux/actions/assetsAction";

const InspectionListContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const locationData = location?.state;
  const Inspcheck = checkPrivileges([12, 139, 144]);
  const openItemInspectionCount = useSelector(
    (state) => state.getInspectionOpenItemCount,
  );

  const divisions = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.divisons,
  );
  const { quesSet } = useSelector((state) => state.inspection);
  const inspectionList = useSelector((state) => state?.inspViewReportList);
  const deleteIns = useSelector((state) => state.inspectionDelete);
  const deleteInsLoading = useSelector(
    (state) => state.inspectionDelete?.isLoading,
  );

  const assetOption = useSelector((state) => state.getAssetDynomoList.data);
  const isAssetLoading = useSelector(
    (state) => state.getAssetDynomoList.isLoading,
  );

  const vehicleCategories = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.vehicleCategories,
  );
  const equipmentCategories = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.equipmentCategories,
  );
  const customAssetCategories = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.assetTypes,
  );

  const getInspectionListData = (data) => {
    dispatch(inspectionAction.getInspectionRportList(data));
    if (!data?.isSendMail) {
      dispatch(inspectionAction.getInspectionViewListFilterObj(data));
    }
  };

  const getQuesSetData = (data) => {
    dispatch(inspectionAction.getQuestionSet(data));
  };

  const searchAsset = (searchText, type, assetCatId, divisionId) => {
    dispatch(
      assetsAction.getAssetDynomoList({
        searchText,
        type,
        assetCatId,
        divisionId,
      }),
    );
  };

  const showLoader = useSelector(
    (state) => state.inspViewReportList?.isLoading,
  );

  const addDefaultCategory = (categories, defaultCategory) => {
    if (!Array.isArray(categories)) {
      categories = [];
    }
    return [{ key: "AllCategory", value: defaultCategory }, ...categories];
  };

  const enhancedVehicleCategories = addDefaultCategory(
    vehicleCategories,
    "All Vehicle",
  );
  const enhancedEquipmentCategories = addDefaultCategory(
    equipmentCategories,
    "All Equipment",
  );
  const enhancedCustomAssetCategories = addDefaultCategory(
    customAssetCategories,
    "All Custom Asset",
  );

  const getDropDownData = (data) => {
    dispatch(adminAction.getDropdownDataKeyValue(data));
  };
  const cleardataInspection = () => {
    dispatch(inspectionAction.clearEmailSuccess());
  };
  useEffect(() => {
    if (!locationData?.assetType) {
      const getDropdownDataKeyValueData = {
        orgId: ORG_ID(),
        flags: [6],
        Clientid: ORG_ID(),
        productId: PRODUCT_ID(),
      };
      getDropDownData(getDropdownDataKeyValueData);
    }
    return () => {
      cleardataInspection();
    };
  }, [locationData]);

  return (
    <>
      {checkPrivileges([12, 16, 4, 5, 6]) ? (
        <>
          <InspectionList
            getInspectionListData={getInspectionListData}
            showLoader={showLoader}
            inspectionList={inspectionList?.inpsViewList}
            locationData={locationData}
            Inspcheck={Inspcheck}
            divisions={divisions}
            quesSet={quesSet}
            getQuesSetData={getQuesSetData}
            isEmailSuccess={inspectionList?.isEmailSuccess}
            deleteIns={deleteIns}
            deleteInsLoading={deleteInsLoading}
            InspectionOpenItemCount={openItemInspectionCount?.data?.result}
            assetOption={assetOption}
            isAssetLoading={isAssetLoading}
            searchAsset={searchAsset}
            vehicleCategories={enhancedVehicleCategories}
            equipmentCategories={enhancedEquipmentCategories}
            customAssetCategories={enhancedCustomAssetCategories}
            getDropDownData={getDropDownData}
            cleardataInspection={cleardataInspection}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default InspectionListContainer;
